// src/components/support/UpdateCaseModal.js

import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '../../api';

const UpdateCaseModal = ({ caseDetails, user, onClose, onCaseUpdated }) => {
    // Initialize form state with the current case details
    const [formData, setFormData] = useState({
        subject: caseDetails.subject || '',
        description: caseDetails.description || '',
        priority: caseDetails.priority || 'MEDIUM',
        status: caseDetails.status || 'OPEN',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        // Since only a SuperAdmin can access this, the payload is always the full form data.
        const payload = formData;

        try {
            await api.updateCase(caseDetails.id, payload);
            toast.success('Case updated successfully!');
            onCaseUpdated();
            onClose();
        } catch (error) {
            toast.error('Failed to update case.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="modal-backdrop">
            <div className="modal">
                <div className="modal-header">
                    <h2>{user.role === 'SuperAdmin' ? 'Edit Case' : 'Update Case Status'}</h2>
                    <button onClick={onClose} className="close-button">&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {/* Fields for SuperAdmin only */}
                        {user.role === 'SuperAdmin' && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="subject">Subject</label>
                                    <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="description">Description</label>
                                    <textarea id="description" name="description" value={formData.description} onChange={handleChange} required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="priority">Priority</label>
                                    <select id="priority" name="priority" value={formData.priority} onChange={handleChange}>
                                        <option value="LOW">Low</option>
                                        <option value="MEDIUM">Medium</option>
                                        <option value="HIGH">High</option>
                                    </select>
                                </div>
                            </>
                        )}
                        
                        {/* Status field is visible to everyone with permission */}
                        <div className="form-group">
                            <label htmlFor="status">Status</label>
                            <select id="status" name="status" value={formData.status} onChange={handleChange}>
                                <option value="OPEN">Open</option>
                                <option value="IN_PROGRESS">In Progress</option>
                                <option value="RESOLVED">Resolved</option>
                            </select>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="button-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="button-primary" disabled={isSubmitting}>
                            {isSubmitting ? 'Updating...' : 'Save Changes'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateCaseModal;